import { render } from "./filePound.vue?vue&type=template&id=c5679676&scoped=true"
import script from "./filePound.vue?vue&type=script&lang=js"
export * from "./filePound.vue?vue&type=script&lang=js"

import "./filePound.vue?vue&type=style&index=0&id=c5679676&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5679676"]])

export default __exports__